import type { SxProps, Theme } from '@mui/material/styles';

/** Shared MUI Select field styles (Epic 90 — readable, clickable, no label overlap). */
export const warehouseSelectFormControlSx = (minWidth: number | string = 280): SxProps<Theme> => ({
  minWidth,
  '& .MuiInputLabel-root': {
    pointerEvents: 'auto',
    cursor: 'pointer',
  },
});

export const warehouseSelectSx: SxProps<Theme> = {
  cursor: 'pointer',
  '& .MuiOutlinedInput-notchedOutline legend': {
    maxWidth: '100%',
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    transform: 'translate(14px, -9px) scale(0.75)',
  },
  '& .MuiSelect-select': {
    display: 'block',
    boxSizing: 'border-box',
    minHeight: 40,
    py: 1.1,
    pr: '32px !important',
    overflow: 'hidden',
    lineHeight: 1.35,
  },
  '& .MuiSelect-select.MuiSelect-select': {
    paddingTop: '14px',
    paddingBottom: '10px',
  },
  '& .MuiSelect-icon': {
    right: 8,
    top: 'calc(50% - 12px)',
  },
};

export const warehouseSelectMenuItemSx: SxProps<Theme> = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
};
